export const numberWithCommas = n => {
  return (n + '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const descriptiveNumbers = n => {
  return Math.abs(+n) >= 1.0e9 // Nine Zeroes for Billions
    ? (Math.abs(+n) / 1.0e9).toFixed(2) + 'b'
    : Math.abs(+n) >= 1.0e6 // Six Zeroes for Millions
      ? (Math.abs(+n) / 1.0e6).toFixed(2) + 'm'
      : Math.abs(+n) >= 1.0e3 // Three Zeroes for Thousands
        ? (Math.abs(+n) / 1.0e3).toFixed(2) + 'k'
        : Math.abs(+n).toFixed(2)
}

export const parseQueryParams = q => {
  return q
    .slice(q.indexOf('?') + 1, q.length)
    .split('&')
    .reduce((result, item) => {
      const parts = item.split('=')
      result[parts[0]] = parts[1]
      return result
    }, {})
}

export default {
  numberWithCommas,
  descriptiveNumbers,
  parseQueryParams
}



// WEBPACK FOOTER //
// ./src/utils/strings.js